<template lang="pug">
  .container.grid-lg
    load-manager(:status="status")
      div(v-if='list.length > 0')
        table.table.table-striped.table-hover.table-sm
          thead
            tr
              th Assunto
              th Para
              th Enviado em
              th(width='1')
          tbody
            tr(v-for="item in list", :key='item.id')
              td {{ item.subject }}
              td {{ item.address_to }}
              td {{ item.sent_at | date }}
              td.text-right(width="1")
                router-link(:to="{ name: 'app.emailHistorico', params: { id: item.id } }")
                  btn-icon(name='show')
      .empty.mt-2(v-else)
        .empty-icon
          i.icon.icon-search
        p.empty-title.h5 Nenhum e-mail foi encontrado
        p.empty-subtitle Clique no botão para voltar
        .empty-action
          button.btn.btn-primary(@click="$router.back()") Voltar

    .my-2.text-right(v-if='pages > 1')
      btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
export default {
  vuex: {
    emailHistoricos: {
      state: [
        'list',
        'page',
        'status',
        'pages',
        'count',
        'query',
        'scope',
        'scope_id',
      ],
      actions: [
        'fetchList',
        'fetchRemove',
        'prevPage',
        'nextPage',
        'firstPage',
        'lastPage',
        'goPage',
      ],
      getters: ['loading'],
      mutations: ['setQuery', 'setPage', 'setScope', 'setScopeId'],
    },
  },

  data() {
    return {
      q: {},
    }
  },

  methods: {
    listar() {
      this.setScope(this.$route.params.scope)
      this.setScopeId(this.$route.params.scope_id)
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },

  created() {
    this.q = { ...this.q, ...this.query }
    this.listar()
  },
}
</script>
